import { createActionTypes } from "@helpers/redux-helpers";

export const createCommentActionTypes = createActionTypes("comments/create");

export const getCommentsActionTypes = createActionTypes("comments/getList");

export const getCommentsPortionActionTypes = createActionTypes(
  "comments/getPortion",
);

export const deleteCommentActionTypes = createActionTypes("comments/delete");

export const likeCommentActionTypes = createActionTypes("comments/likes/like");
export const unlikeCommentActionTypes = createActionTypes(
  "comments/likes/unlike",
);

export const editCommentActionTypes = createActionTypes("comments/edit");

export const setEditCommentIdActionType = "comments/setEdit";
export const resetEditCommentIdActionType = "comments/setEdit/reset";
